import { useCallback } from 'react';
import UISelect from 'UIComponents/input/UISelect';
import useUIMode, { useOnChangeUIMode } from 'framework-listing-lib/internal/hooks/useUIMode';
import listingLibObserver from 'framework-listing-lib/utils/listingLibObserver';
import useCrmObjectTypeTracking from 'framework-listing-lib/internal/hooks/useCrmObjectTypeTracking';
import useExpandCollapseRow from 'framework-listing-lib/hooks/useExpandCollapseRow';
import { useUIModeSelectOptions } from 'framework-listing-lib/internal/hooks/useUIModeSelectOptions';
import { useViewUpdateState } from 'framework-listing-lib/internal/ViewTabs/hooks/useViewProps';
import useCurrentView from 'framework-listing-lib/hooks/useCurrentView';
import { UI_MODE } from 'framework-listing-lib/constants';
import useCrmObjectTypeListingPagination from 'framework-listing-lib/internal/hooks/useCrmObjectTypeListingPagination';
import { DEFAULT_GALLERY_PAGE_SIZE, DEFAULT_PAGE_SIZE } from 'framework-listing-lib/constants/pagination';
import { jsx as _jsx } from "react/jsx-runtime";
export default function TableUIModeSelect() {
  const [, setViewUpdateState] = useViewUpdateState();
  const currentView = useCurrentView();
  const {
    uiModeOptions,
    shouldDisplaySelect
  } = useUIModeSelectOptions();
  const {
    currentUIMode
  } = useUIMode();
  const onChangeUIMode = useOnChangeUIMode();
  const {
    trackCrmTableInteraction
  } = useCrmObjectTypeTracking();
  const {
    collapseAll
  } = useExpandCollapseRow();
  const {
    onPageSizeChange
  } = useCrmObjectTypeListingPagination();
  const handleChange = useCallback(({
    target: {
      value: newUIMode
    }
  }) => {
    if (currentUIMode === newUIMode) {
      return;
    }
    listingLibObserver.changeUIMode(newUIMode);
    trackCrmTableInteraction({
      action: 'change-ui-mode',
      newUIMode
    });
    collapseAll();
    if (newUIMode === UI_MODE.GALLERY) {
      onPageSizeChange(DEFAULT_GALLERY_PAGE_SIZE);
    }
    if (currentUIMode === UI_MODE.GALLERY) {
      onPageSizeChange(DEFAULT_PAGE_SIZE);
    }
    onChangeUIMode(newUIMode);
    if (currentView) {
      setViewUpdateState(prev => Object.assign({}, prev, {
        changedUIMode: currentView.state.uiMode ? currentView.state.uiMode !== newUIMode : newUIMode !== UI_MODE.LIST
      }));
    }
  }, [collapseAll, currentUIMode, currentView, onChangeUIMode, onPageSizeChange, setViewUpdateState, trackCrmTableInteraction]);
  if (!shouldDisplaySelect) {
    return null;
  }
  return /*#__PURE__*/_jsx(UISelect, {
    "data-test-id": "table-ui-mode-select",
    defaultValue: currentUIMode,
    buttonUse: "tertiary-extra-light",
    buttonSize: "xs",
    placement: "bottom left",
    menuWidth: "auto",
    onChange: handleChange,
    options: uiModeOptions
  });
}